import { initReview } from "./review.ts";

import "./reviews.css";
import "@/other/paginator/paginator.css";

function initReviews() {
  initReview();
}
export { initReviews };
